import { render, staticRenderFns } from "./BaFilters.vue?vue&type=template&id=b7625680&scoped=true&"
import script from "./BaFilters.vue?vue&type=script&lang=js&"
export * from "./BaFilters.vue?vue&type=script&lang=js&"
import style0 from "./BaFilters.vue?vue&type=style&index=0&id=b7625680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7625680",
  null
  
)

export default component.exports